export default __webpack_public_path__ + "static/media/add-file.f94f5380.svg";